<template>
  <BaseInlineSvg
    :class="renderClass"
    :isActive="modelValue"
    :src="require('@/lib/tui/components/buttons/Refacto/checkbox_2.svg')"
  >
  </BaseInlineSvg>
</template>

<script>
import BaseInlineSvg from "@/lib/tui/components/display/BaseInlineSvg.vue";
export default {
  name: "BaseCheckbox",
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  components: {
    BaseInlineSvg,
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  props: {
    id: [String, Number],
    target: [String, Number],
    modelValue: Boolean,
    classState: String
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  data () {
    return {
      hover: false
    }
  },
  ////////////////////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////
  computed: {
    renderClass: function() {
      let newClass = this.classState;
      
      newClass += this.modelValue ? " on" : " off";
      return newClass;
    }
  }
};
</script>

<style lang="scss">
  @import "@/lib/tui/scss/module/baseCheckbox.scss";
</style>